// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_alerts.styl
// module id = 63
// module chunks = 0